import Home from "./Home";

const LandingPage = (props) => {
  return (
    <>
      <Home data={props.data} />
    </>
  );
};

export default LandingPage;
